<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Magazzino ricambi</h2>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">Nuovo ricambio</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="lista" :items-per-page="15" density="comfortable">
            <template #[`item.nome`]="{ item }">
                <v-icon v-if="item.sottoScorta" color="error" size="small" class="mr-1"
                    title="Sotto scorta minima">mdi-alert</v-icon>
                {{ item.nome }}
            </template>
            <template #[`item.quantitaDisponibile`]="{ item }">
                <span :class="item.sottoScorta ? 'text-error font-weight-bold' : ''">
                    {{ item.quantitaDisponibile }} {{ item.unitaMisura }}
                </span>
            </template>
            <template #[`item.costo`]="{ item }">
                {{ item.costo != null ? item.costo.toFixed(2) + ' €' : '—' }}
            </template>
            <template #[`item.azioni`]="{ item }">
                <v-btn icon variant="text" size="small" title="Duplica" @click="duplica(item)">
                    <v-icon>mdi-content-copy</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" @click="apriDialog(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" color="error" @click="elimina(item)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="480">
            <v-card>
                <v-card-title>{{ form.id ? 'Modifica ricambio' : 'Nuovo ricambio' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formRef">
                        <v-text-field v-model="form.nome" label="Nome" :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model="form.codice" label="Codice" />
                        <v-textarea v-model="form.descrizione" label="Descrizione" rows="2" />
                        <v-row>
                            <v-col cols="4">
                                <v-text-field v-model.number="form.quantitaDisponibile" type="number"
                                    label="Quantità" />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model.number="form.scortaMinima" type="number" label="Scorta minima" />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model="form.unitaMisura" label="Unità (pz, kg...)" />
                            </v-col>
                        </v-row>
                        <v-text-field v-model.number="form.costo" type="number" step="0.01"
                            label="Costo unitario (€)" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialog = false">Annulla</v-btn>
                    <v-btn color="primary" @click="salva">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "MagazzinoPage",

    data() {
        return {
            dialog: false,
            form: this.formVuoto(),
            headers: [
                { title: "Nome", key: "nome" },
                { title: "Codice", key: "codice" },
                { title: "Quantità", key: "quantitaDisponibile" },
                { title: "Costo", key: "costo" },
                { title: "", key: "azioni", sortable: false },
            ],
        };
    },

    computed: {
        lista() {
            return this.$store.getters["ricambi/lista"];
        },
    },

    mounted() {
        this.$store.dispatch("ricambi/carica");
    },

    methods: {
        formVuoto() {
            return {
                id: null,
                codice: "",
                nome: "",
                descrizione: "",
                quantitaDisponibile: 0,
                scortaMinima: null,
                costo: null,
                unitaMisura: "pz",
            };
        },

        apriDialog(item) {
            this.form = item ? { ...item } : this.formVuoto();
            this.dialog = true;
        },

        async salva() {
            if (!this.$refs.formRef.validate()) return;
            try {
                const { id, ...dati } = this.form;
                await this.$store.dispatch("ricambi/salva", { id, dati });
                this.dialog = false;
            } catch (error) {
                console.log(error);
            }
        },

        async elimina(item) {
            try {
                await this.$store.dispatch("ricambi/elimina", item.id);
            } catch (error) {
                console.log(error);
            }
        },

        async duplica(item) {
            try {
                await this.$store.dispatch("ricambi/duplica", item.id);
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>